module.exports = __webpack_public_path__ + "img/ic_net.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/ic_net.png
// module id = 744
// module chunks = 0